import { render, staticRenderFns } from "./AccountTab.vue?vue&type=template&id=0c75b752&scoped=true&"
import script from "./AccountTab.vue?vue&type=script&lang=js&"
export * from "./AccountTab.vue?vue&type=script&lang=js&"
import style0 from "./AccountTab.vue?vue&type=style&index=0&id=0c75b752&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c75b752",
  null
  
)

export default component.exports